/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { HumanityGasPriceInfo } from '../models/HumanityGasPriceInfo';
import type { HumanityGasPriceRequest } from '../models/HumanityGasPriceRequest';
import type { HumanityGasSummaryInfo } from '../models/HumanityGasSummaryInfo';
import type { HumanityGasSummaryRequest } from '../models/HumanityGasSummaryRequest';
import type { HumanityMedianGasFeeInfo } from '../models/HumanityMedianGasFeeInfo';
import type { HumanityMedianGasFeeRequest } from '../models/HumanityMedianGasFeeRequest';
import type { HumanityTopGasSpenderInfo } from '../models/HumanityTopGasSpenderInfo';
import type { HumanityTopGasSpenderRequest } from '../models/HumanityTopGasSpenderRequest';
import type { KiteGasPriceInfo } from '../models/KiteGasPriceInfo';
import type { KiteGasPriceRequest } from '../models/KiteGasPriceRequest';
import type { KiteGasSummaryInfo } from '../models/KiteGasSummaryInfo';
import type { KiteGasSummaryRequest } from '../models/KiteGasSummaryRequest';
import type { KiteMedianGasFeeInfo } from '../models/KiteMedianGasFeeInfo';
import type { KiteMedianGasFeeRequest } from '../models/KiteMedianGasFeeRequest';
import type { KiteTopGasSpenderInfo } from '../models/KiteTopGasSpenderInfo';
import type { KiteTopGasSpenderRequest } from '../models/KiteTopGasSpenderRequest';
import type { ZerogTopGasSpenderInfo } from '../models/ZerogTopGasSpenderInfo';
import type { ZerogTopGasSpenderRequest } from '../models/ZerogTopGasSpenderRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class GasControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getTopGasSpender({
        requestBody,
    }: {
        requestBody: (HumanityTopGasSpenderRequest | KiteTopGasSpenderRequest | ZerogTopGasSpenderRequest),
    }): CancelablePromise<(HumanityTopGasSpenderInfo | KiteTopGasSpenderInfo | ZerogTopGasSpenderInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/gas/top-spender',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getGasTrackerSummary({
        requestBody,
    }: {
        requestBody: (HumanityGasSummaryRequest | KiteGasSummaryRequest),
    }): CancelablePromise<(HumanityGasSummaryInfo | KiteGasSummaryInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/gas/summary',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getGasPrice({
        requestBody,
    }: {
        requestBody: (HumanityGasPriceRequest | KiteGasPriceRequest),
    }): CancelablePromise<(HumanityGasPriceInfo | KiteGasPriceInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/gas/price/tier',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getMedianGasPriceChart({
        requestBody,
    }: {
        requestBody: (HumanityMedianGasFeeRequest | KiteMedianGasFeeRequest),
    }): CancelablePromise<(HumanityMedianGasFeeInfo | KiteMedianGasFeeInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/gas/median/fee',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
